import AddCountry from "../AddCountry";
import CommonAuthHeader from "./CommonAuthHeader";

const AddCountryOptions = () => {
  return (
    <CommonAuthHeader shouldShowBackButton={false}>
      <AddCountry isFromBrowser />
    </CommonAuthHeader>
  );
};

export default AddCountryOptions;
